
import { ActivityCodeApi } from "@/api/ActivityCodeApi";
import { ExpenseCategoryApi } from "@/api/ExpenseCategoryApi";
import { FormConfigType } from "@/types/dynamicForm";
import { SELECT_INPUT_TYPE, VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";
import { ATV_RESPONSES, TAXES_CONDITIONS } from "@utils/Constants";

const ProviderInvoiceMessageFormonfig: FormConfigType = {
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "type": "text",
                        "name": "reference_number",
                        "label": "Numero Referencia",
                        "isHorizontal": true,
                        "visibilityHiddenIf": () => true, // by default this input is hidden, suscrption data make it visible
                        "labelSizing": {
                            "sm": {
                                "size": 2
                            }
                        },
                        "sizing": {
                            "sm": {
                                "size": 2
                            }
                        },
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "mensaje",
                        "isHorizontal": true,
                        "validation": Yup.string().required(),
                        "label": "Mensaje Respuesta",
                        "labelSizing": {
                            "sm": {
                                "size": 2
                            }
                        },
                        "sizing": {
                            "sm": {
                                "size": 4
                            }
                        },
                        "options": ATV_RESPONSES,
                    }
                ],
                [
                    {
                        "type": "text",
                        "name": "detalle",
                        "isHorizontal": true,
                        "label": "Detalle",
                        "labelSizing": {
                            "sm": {
                                "size": 2
                            }
                        },
                        "sizing": {
                            "sm": {
                                "size": 8
                            }
                        },
                    }
                ],
                [
                    {
                        "type": "number",
                        "name": "numero",
                        "label": "Numero Factura",
                        "isHorizontal": true,
                        "sizing": {
                            "sm": 4
                        },
                        "labelSizing": {
                            "sm": 2
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "expenseCategoryId",
                        "label": "Categoria Gasto",
                        "optionsFunction": () => ExpenseCategoryApi.optionsList(),
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 6
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "activitycode",
                        "isHorizontal": true,
                        "label": "Actividad Economica",
                        "optionsFunction": () => ActivityCodeApi.optionsList({}, undefined, "code"),
                        "labelSizing": {
                            "sm": {
                                "size": 2
                            }
                        },
                        "sizing": {
                            "sm": {
                                "size": 4
                            }
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "condicionImpuesto",
                        "isHorizontal": true,
                        "label": "Condicion Impuesto",
                        "options": TAXES_CONDITIONS,
                        "labelSizing": {
                            "sm": {
                                "size": 2
                            }
                        },
                        "sizing": {
                            "sm": {
                                "size": 5
                            }
                        }
                    },
                ],
                [
                    {
                        "type": "money",
                        "isDecimal": true,
                        "name": "impuestoAcreditar",
                        "label": "Monto Total Impuesto Acreditar",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "money",
                        "isDecimal": true,
                        "name": "gastoAplicable",
                        "label": "Monto Total de Gasto Aplicable",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
            ]
        }
    ],
};


export default ProviderInvoiceMessageFormonfig;